module.exports = __webpack_public_path__ + "img/erp-logos_0002_xero.2cf0c5c5.jpg";